import { observable, action, } from 'mobx';
import { Injectable } from '@angular/core';
import { DataService } from '../services/data.service';
import { pushToArray } from '../services/mapping.service';

@Injectable()
export class AppCenter {
    @observable data: any[] = [];
    @observable process: boolean = false;
    @observable loading: boolean = true;
    @observable empty: boolean = false;
    
    constructor(private ds: DataService) { }

}
